import { FC } from 'react';
import { MediaQueries } from '@frontend/api-media';
import { Image } from '@frontend/design-system';
import { assetStyle } from './media-preview.styles';

type MediaResult = NonNullable<MediaQueries.UseMmsMediaItem['data']>;

export const MediaPreviewItem: FC<MediaResult> = ({ mediaId, src, contentType }) => {
  if (contentType.startsWith('image/')) {
    return <Image src={src} alt={`Media ${mediaId}`} css={assetStyle} />;
  } else if (contentType.startsWith('video/')) {
    // This might not be rendered at any time, because with sms we cannot attach a video
    return (
      <video controls css={assetStyle}>
        <source src={src} type={contentType} />
      </video>
    );
  } else if (contentType.startsWith('application/pdf')) {
    // This might not be rendered at any time, because with sms we cannot attach a pdf
    return <iframe src={src} title={`Media ${mediaId}`} css={assetStyle} />;
  }
  return null;
};
